import { render, staticRenderFns } from "./defaultWithoutVuePerfectScrollbar.vue?vue&type=template&id=f6dca1e4&scoped=true"
import script from "./defaultWithoutVuePerfectScrollbar.vue?vue&type=script&lang=js"
export * from "./defaultWithoutVuePerfectScrollbar.vue?vue&type=script&lang=js"
import style0 from "./defaultWithoutVuePerfectScrollbar.vue?vue&type=style&index=0&id=f6dca1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dca1e4",
  null
  
)

export default component.exports